import React, { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_gland-positioning/artifacts/7ajvflo3_92bd96a0-d046-433e-8e54-c913844612a9.jpeg";

export const Header = ({ onJoinClick }) => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const navLinks = [
    { label: "Problem", href: "#problem" },
    { label: "Solution", href: "#solution" },
    { label: "Features", href: "#features" },
    { label: "Story", href: "#story" },
    { label: "Roadmap", href: "#roadmap" },
  ];

  return (
    <header
      data-testid="main-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-black/80 backdrop-blur-xl border-b border-[#27272A]"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16">
        <div className="flex items-center justify-between h-16 md:h-20">
          <a
            href="#top"
            data-testid="nav-logo"
            className="flex items-center gap-3 group"
          >
            <img
              src={LOGO_URL}
              alt="AdjustaGland PRO"
              className="h-10 md:h-11 w-auto"
            />
          </a>

          <nav className="hidden md:flex items-center gap-9">
            {navLinks.map((l) => (
              <a
                key={l.href}
                href={l.href}
                data-testid={`nav-link-${l.label.toLowerCase()}`}
                className="text-[13px] font-mono-spec uppercase tracking-[0.18em] text-[#A1A1AA] hover:text-white transition-colors"
              >
                {l.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <button
              data-testid="header-join-waitlist-btn"
              onClick={onJoinClick}
              className="hidden sm:inline-flex btn-primary !py-2.5 !px-4 text-[12px]"
            >
              Join Waitlist
            </button>
            <button
              data-testid="mobile-menu-toggle"
              onClick={() => setOpen((v) => !v)}
              className="md:hidden w-10 h-10 grid place-items-center border border-[#27272A] rounded-sm"
              aria-label="Toggle menu"
            >
              {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
            </button>
          </div>
        </div>

        {open && (
          <div
            data-testid="mobile-menu"
            className="md:hidden border-t border-[#27272A] py-4 flex flex-col gap-3"
          >
            {navLinks.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="font-mono-spec uppercase tracking-[0.18em] text-sm text-[#A1A1AA] hover:text-white py-2"
              >
                {l.label}
              </a>
            ))}
            <button
              data-testid="mobile-join-waitlist-btn"
              onClick={() => {
                setOpen(false);
                onJoinClick();
              }}
              className="btn-primary w-full mt-2"
            >
              Join Waitlist
            </button>
          </div>
        )}
      </div>
    </header>
  );
};
